export default __webpack_public_path__ + "static/media/ic__tips.55d688fd.svg";